import { useState, useRef } from "react"
import stringHelpers from "../../utilities/stringHelpers"

export const DateTimePickerWithCustomDisplay = ({ value, onChange, customDisplayText }) => {
    const [isFocused, setIsFocused] = useState(false)
    const inputRef = useRef()

    return (
        <div className="input-group date-time-custom-display">
            <div className="position-relative">
                <input
                    ref={ inputRef }
                    className="form-control"
                    type="datetime-local"
                    value={ value }
                    onChange={ (e) => onChange(e.target.value) }
                    onFocus={ () => setIsFocused(true) }
                    onBlur={ () => setIsFocused(false) }
                />
                {
                    !isFocused && (stringHelpers.isNullOrEmpty(value) || value === "yyyy-MM-dd") &&
                    <span
                        className="fs--1 position-absolute d-flex align-items-center justify-content-between bg-white text-danger pl-3 pr-2">
                        { customDisplayText }
                        <i
                            className="far fa-calendar text-black"
                            onClick={ () => {
                                if (inputRef.current) {
                                    inputRef.current.showPicker()
                                }
                            } }
                        ></i>
                    </span>
                }
            </div>
            <div className="input-group-append">
                <button onClick={ () => onChange("") } type="button" className="btn btn-falcon-default">Clear</button>
            </div>
        </div>
    )
}